export const environment = {
  production: window['env']['production'] || false,
  apiUrl: window['env']['apiUrl'] || 'https://sd.iomtdev.bbraun.io/api/v1',
  apiV2Url: window['env']['apiV2Url'] || 'https://sd.iomtdev.bbraun.io/api/v2',
  adminUrl: window['env']['adminUrl'] || 'https://portal.iomtdev.bbraun.io/admin/',
  dfmUrl: window['env']['dfmUrl'] || 'https://portal.iomtdev.bbraun.io',
  loginUrl: window['env']['loginUrl'] || 'https://test.account.bbraun.com/dadf93c1-1d2f-487d-a595-5d5428a9ae96/oauth2/v2.0/authorize?p=b2c_1a__signup_signin_mfa',
  logoutUrl: window['env']['logoutUrl'] || 'https://test.account.bbraun.com/dadf93c1-1d2f-487d-a595-5d5428a9ae96/b2c_1a__signup_signin_mfa/oauth2/v2.0/logout',
  wellKnownUrl: window['env']['wellKnownUrl'] ?? 'https://test.account.bbraun.com/dadf93c1-1d2f-487d-a595-5d5428a9ae96/v2.0/.well-known/openid-configuration?p=B2C_1A__SIGNUP_SIGNIN_MFA',
  issuer: window['env']['issuer'] || 'https://test.account.bbraun.com/dadf93c1-1d2f-487d-a595-5d5428a9ae96/B2C_1A__SIGNUP_SIGNIN_MFA/v2.0/',
  clientId: window['env']['clientId'] || '249a5990-d532-4267-8437-ad467bc1a56e',
  scope: window['env']['scope'] || 'openid profile offline_access https://test.account.bbraun.com/86f5ef58-2768-48bc-aafc-56e0cbac8a4b/User.Permission.Read',
  trackingUi: {
    enable: false,
    reportingUrl: ''
  }
};
